import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const GLCodeDropDownCell: FC<GridCellProps> = (props) => {
  const { dataItem, onChange, dataIndex, field } = props;
  const { errors = [] } = dataItem;
  const glCodeOptions = useContextSelector(InvoiceContext, (value) => value.glCodeOptions);

  const isDisabled = !dataItem.selected;
  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  let value = glCodeOptions.find((glCodeData) => glCodeData?.value === dataItem.value);

  return (
    <GridCellBase {...props} title={value?.label} className={'!bg-transparent'}>
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <DropDown
          onChange={handleChange}
          value={dataItem.value}
          options={glCodeOptions}
          disabled={isDisabled}
          valid={!errors.length}
        />
      </div>
    </GridCellBase>
  );
};

export default GLCodeDropDownCell;
